'use es6';

export const getHublDocs = state => state.hublDocs.docs;